/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.AssociatedFilesResponseDto>>;
export function request(
  params: API.tms.associatedFiles.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/associatedFiles/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
